// notice.js - 通知窗口状态管理模块
const state = {
  // 通知窗口显示状态
  visible: false,
  // 通知类型: 'update' 更新日志, 'maintenance' 版本维护
  noticeType: 'update',
  // 标题
  title: '系统通知',
  // 内容
  content: '',
  // 确认按钮文字
  confirmText: '我知道了',
  // 是否显示底部
  showFooter: true,
  // 点击背景是否可关闭
  backdropCloseable: true,
  // 回调函数
  onConfirm: null,
  onClose: null
}

const mutations = {
  // 显示通知窗口
  SHOW_NOTICE(state, payload) {
    state.visible = true
    state.noticeType = payload.noticeType || 'update'
    state.title = payload.title || '系统通知'
    state.content = payload.content || ''
    state.confirmText = payload.confirmText || '我知道了'
    state.showFooter = payload.showFooter !== undefined ? payload.showFooter : true
    state.backdropCloseable = payload.backdropCloseable !== undefined ? payload.backdropCloseable : true
    state.onConfirm = payload.onConfirm || null
    state.onClose = payload.onClose || null
  },
  // 隐藏通知窗口
  HIDE_NOTICE(state) {
    state.visible = false
    // 重置状态
    state.noticeType = 'update'
    state.title = '系统通知'
    state.content = ''
    state.confirmText = '我知道了'
    state.showFooter = true
    state.backdropCloseable = true
    state.onConfirm = null
    state.onClose = null
  }
}

const actions = {
  // 显示更新日志通知
  showUpdateNotice({ commit }, payload) {
    commit('SHOW_NOTICE', {
      ...payload,
      noticeType: 'update'
    })
  },
  // 显示维护通知
  showMaintenanceNotice({ commit }, payload) {
    commit('SHOW_NOTICE', {
      ...payload,
      noticeType: 'maintenance',
      backdropCloseable: false // 维护通知不允许点击背景关闭
    })
  },
  // 隐藏通知
  hideNotice({ commit, state }) {
    // 执行关闭回调
    if (state.onClose && typeof state.onClose === 'function') {
      state.onClose()
    }
    commit('HIDE_NOTICE')
  },
  // 确认通知
  confirmNotice({ commit, state }) {
    // 执行确认回调
    if (state.onConfirm && typeof state.onConfirm === 'function') {
      state.onConfirm()
    }
    // 如果是更新日志，确认后自动关闭
    if (state.noticeType === 'update') {
      commit('HIDE_NOTICE')
    }
  }
}

const getters = {
  // 获取通知状态
  noticeState: state => state,
  // 是否可关闭
  isCloseable: state => state.noticeType === 'update'
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 